import {
  createTileSelectionGroup,
  type TileSelectionItemProps,
} from "@ui/components/internal/TileSelectionGroup/createTileSelectionGroup";
import type { TileVariants } from "@ui/components/Tile/styles";
import {
  RadioGroup as BaseRadioGroup,
  type RadioGroupProps as BaseRadioGroupProps,
  Radio,
} from "@ui/primitives/RadioGroup";
import type { ReactNode } from "react";

export interface TileRadioGroupProps extends BaseRadioGroupProps {
  children: ReactNode;
  color?: TileVariants["color"];
  /** Set to `null` to hide the radio indicator (tile selection mode). */
  control?: TileVariants["control"] | null;
  hierarchy?: TileVariants["hierarchy"];
  shape?: TileVariants["shape"];
  size?: TileVariants["size"];
  align?: "vertical" | "horizontal";
}

export interface TileRadioGroupItemProps extends TileSelectionItemProps {}

export const TileRadioGroup: ((props: TileRadioGroupProps) => ReactNode) & {
  Item: (props: TileRadioGroupItemProps) => ReactNode;
} = createTileSelectionGroup<BaseRadioGroupProps>({
  Group: BaseRadioGroup,
  Item: Radio,
  defaultControl: "radio",
});
